import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const BenefitsProduct = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Multi-versatile Tool</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              Product video production flexible format allows you to show your product’s benefits on all platforms. These captivating explainer videos
              can be used on social media, websites, and email marketing. Introduce your product’s strengths with the most suitable type of
              visualization. Beautifully personalize your brand without thinking about restriction. Video format can leave an impact no matter what
              kind of product you offer.
            </div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Higher Engagement</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              With its captivating script and dynamic movements, it captions the main benefits and uniqueness of your product. Custom video production
              services make it possible for your brand to leave a memorable impact and influence on the market. The mixture of these aspects
              guarantees the engagement of new customers and the growth of product sales.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Dynamic Communication </h3>
          Product video production will provide straight communication with your audience. Visualized explanations of your benefits, popping up the
          updates, will keep a reliable contact between you and your customers. Usage of our product explainer videos will become an ice-breaker in
          your client relationships.
        </div>
      </Slider>
    </>
  );
};
export default BenefitsProduct;
